export default __webpack_public_path__ + "static/media/rank-earn-exp.e6d8a793.png";